import React, { useState, useEffect } from 'react';
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { Card, Button, Modal, Row, Col, Alert, Spinner, Nav, Tab, Image, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import StripeProvider from './StripeProvider';
import { FaDownload } from 'react-icons/fa';
import DisputeModal from "../../../components/common/modals/DisputeModal"
import DateChangeReviewModal from '../../../components/common/modals/DateChangeReviewModal';
import config from '../../../config.json';


import {
    Container,
    Form,
} from 'react-bootstrap';
import {
    FaArrowLeft as ArrowLeft,
    FaCalendar as Calendar,
    FaTimesCircle as Clock,
    FaCheckCircle as CheckCircle,
    FaFileExport as FileEarmarkText,
    FaUpload as Upload,
    FaDownload as Download,
    FaChartLine as ChatDots,
    FaPersonBooth,
    FaFile,
    FaInfoCircle,
    FaCircle,
    FaCalendarAlt
} from 'react-icons/fa';
import Header from '../../../components/user/common/Header';
import PageTitle from '../../../components/user/common/PageTitle';
import { Helmet } from 'react-helmet';
import SpinnerLoader from '../../../components/common/SpinnerLoader';
import { useHistory } from 'react-router-dom';
import ServiceModel from '../../../components/user/common/services/ServiceModel';
import ProductModel from '../../../components/user/common/ProductModel';
import ContentUnavailable from '../../../components/common/ContentUnavailable';

function OrderDetailsPage() {
    const { projectId } = useParams();
    const history = useHistory();
    const stripe = useStripe();
    const elements = useElements();
    const authInfo = useSelector(s => s.auth.authInfo);

    const [project, setProject] = useState(null);
    const [milestones, setMilestones] = useState([]);
    const [key, setKey] = useState('overview');
    const [selected, setSelected] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [clientSecret, setClientSecret] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingProject, setLoadingProject] = useState(false);
    const [error, setError] = useState('');
    const [openReviewModal, setOpenReviewModal] = useState(false);
    const [check, setCheck] = useState(false);

    const [isProductProject, setIsProductProject] = useState(false);
    const [productId, setProductId] = useState(null);

    const [projectReview, setProjectReview] = useState(null);
    const [milestoneLoading, setMilestoneLoading] = useState({});

    const [existingDispute, setExistingDispute] = useState(null);

    const [showDateChangeReviewModal, setShowDateChangeReviewModal] = useState(false);
    const [selectedMilestone, setSelectedMilestone] = useState(null);

    const [globalFlatFee, setGlobalFlatFee] = useState(null)
    const [globalPercentageFee, setGlobalPercentageFee] = useState(null)
    const [feeType, setFeeType] = useState('flat')
    const [vatGstEnabled, setVatGstEnabled] = useState(false)
    const [vatGstLabel, setVatGstLabel] = useState('VAT/GST')
    const [paymentBreakdown, setPaymentBreakdown] = useState(null)
    const [loadingMilestoneId, setLoadingMilestoneId] = useState(null);

    //console.log("HELLO", flatFee)

    const handleDateChangeReview = (milestone) => {
        setSelectedMilestone(milestone);
        setShowDateChangeReviewModal(true);
    };

    const handleDateChangeReviewSuccess = (updatedMilestone) => {
        // Update the milestone in your local state
        setMilestones(prev =>
            prev.map(m =>
                m._id === updatedMilestone._id ? updatedMilestone : m
            )
        );
        setShowDateChangeReviewModal(false);
        setSelectedMilestone(null);

        // Refresh project data
        fetchUpdatedProject();
    };

        // Fetch disputes when project loads
        useEffect(() => {
        if (project) {
            checkProjectDisputes();
            handleGetFlatFee()
        }
        }, [project]);

        const checkProjectDisputes = async () => {
        try {
            const endpoint = authInfo.id === project.clientId._id ? '/user/disputes' : '/seller/disputes';
            const response = await axios.get(endpoint, {
            headers: { Authorization: `Bearer ${authInfo.token}` },
            params: {
                projectId: project._id,
                status: 'open,under-review'
            }
            });

            if (response.data.status && response.data.data.length > 0) {
                setCheck(true);
                   setExistingDispute(response.data.data[0]);
            }
        } catch (error) {
            console.error('Error checking disputes:', error);
        }
    };

    useEffect(() => {
        const fetchReview = async () => {
            if (!projectId || project?.isProductProject === undefined) return;

            try {
                const url = project.isProductProject
                    ? `/user/product-review/${projectId}`
                    : `/user/service-review/${projectId}`;

                const res = await axios.get(url, {
                    headers: { Authorization: `Bearer ${authInfo.token}` }
                });

                if (res.data.success) {
                    setProjectReview(res.data.review); // Set separate review state
                    console.log('Fetched review:', res.data.review);
                }
            } catch (err) {
                console.error('No review found or error:', err);
            }
        };

        fetchReview();
    }, [projectId, project?.isProductProject]);



    useEffect(() => {
        if (!authInfo?.token) return;
        setLoadingProject(true);
        axios.get(`/user/project/${projectId}`, {
            headers: { Authorization: `Bearer ${authInfo.token}` }
        })
            .then(res => {
                const { project, milestones } = res.data;
                setProject(project);
                setMilestones(milestones);
                // Extract isProductProject and productId into separate variables
                setIsProductProject(project?.isProductProject || false);
                setProductId(project?.productId || null);
            })
            .catch(err => {
                console.error(err);
                toast.error('Failed to load contract details.');
            }).finally(() => {
                setLoadingProject(false)
            })
    }, [projectId, authInfo]);

    const payMilestone = async (m) => {
        setError('');
        setLoadingMilestoneId(m._id);
        setPaymentBreakdown(null);
        try {
            const fee = feeType === 'percentage'
                ? (Number(m.amount) * Number(globalPercentageFee || 0)) / 100
                : Number(globalFlatFee || 0);
            const preTaxTotal = Number((Number(m.amount) + fee).toFixed(2));
            const { data } = await axios.post(
            '/user/milestone/create-payment-intent',
            {
                amount: preTaxTotal,
                milestoneId: m._id,
                projectId,
                clientId: authInfo.id,
                sellerId: m.assignedTo._id,
                description: m.description
            },
            {
                headers: { Authorization: `Bearer ${authInfo.token}` }
            }
            );

            // update milestone status locally
            setMilestones(prev =>
            prev.map(item =>
                item._id === m._id ? { ...item, status: 'in-progress' } : item
            )
            );

            setClientSecret(data.clientSecret);
            setPaymentBreakdown(data.breakdown || null);
            setSelected(m);
            setShowModal(true);
        } catch (err) {
            console.error(err);
            toast.error('Could not initialize payment.');
        } finally {
            setLoadingMilestoneId(null); // reset loading state
        }
    };

    const acceptMilestone = async (m) => {
        try {
            // Set loading for this specific milestone
            setMilestoneLoading(prev => ({ ...prev, [m._id]: true }));

            await axios.post(
                `/user/milestone/${m._id}/approve`,
                { milestoneId: m._id, userId: authInfo.id },
                { headers: { Authorization: `Bearer ${authInfo.token}` } }
            );

            toast.success('Milestone accepted. You can now release payment.');

            // Update milestone status
            setMilestones(prev => prev.map(x => x._id === m._id ? { ...x, status: 'approved' } : x));

            // Fetch updated project data
            await fetchUpdatedProject();

        } catch (error) {
            console.error('Error accepting milestone:', error);
            toast.error('Unable to accept milestone.');
        } finally {
            // Remove loading for this specific milestone
            setMilestoneLoading(prev => ({ ...prev, [m._id]: false }));
        }
    };

    const rejectMilestone = async (m, rejectionReason = '') => {
        try {
            await axios.post(`/user/milestone/${m._id}/reject`, {
                milestoneId: m._id,
                userId: authInfo.id,
                notes: rejectionReason
            }, {
                headers: { Authorization: `Bearer ${authInfo.token}` }
            });

            toast.success('Milestone rejected.');

            // Update milestone status to rejected
            setMilestones(prev => prev.map(x =>
                x._id === m._id ? { ...x, status: 'rejected' } : x
            ));

            // Fetch updated project data
            fetchUpdatedProject();

        } catch (error) {
            console.error('Error rejecting milestone:', error);
            toast.error('Unable to reject milestone.');
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setError('');
        if (!stripe || !elements) return;
        setLoading(true);
        const cardElem = elements.getElement(CardNumberElement);
        if (!cardElem) {
            setError('Please fill in card details.');
            setLoading(false);
            return;
        }
        const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(clientSecret, { payment_method: { card: cardElem } });
        if (stripeErr) {
            setError(stripeErr.message);
            setLoading(false);
            return;
        }
        try {
            await axios.post(
                '/user/milestone/process-payment',
                { paymentIntentId: paymentIntent.id, milestoneId: selected._id },
                { headers: { Authorization: `Bearer ${authInfo.token}` } }
            );
            toast.success('Payment received.');
            setShowModal(false);

            // Only update milestone status
            setMilestones(ms => ms.map(item => item._id === selected._id ? { ...item, status: 'paid' } : item));

            // Fetch updated project data from backend
            fetchUpdatedProject();

        } catch (err) {
            console.error(err);
            setError('Server failed to confirm payment.');
        } finally {
            setLoading(false);
        }
    };
    const fetchUpdatedProject = async () => {
        try {
            const response = await axios.get(`/user/project/${projectId}`, {
                headers: { Authorization: `Bearer ${authInfo.token}` }
            });

            if (response.data.project) {
                setProject(response.data.project);
            }
        } catch (error) {
            console.error('Failed to fetch updated project:', error);
        }
    };
    const handleChat = (clientId) => {
        history.push({
            pathname: `/chat`,
            state: {
                targetUserId: clientId,
                clientId: clientId,
            }
        });
    }
    const formatDate = iso => new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });

    if (!project) {
        if (loadingProject) {
            return <Spinner animation="border" className="m-5" />;
        }
        return (
            <>
                <Helmet><title>{"My Order - Pay Earth"}</title></Helmet>
                <Header />
                <PageTitle title="My Orders" />
                <Container className="py-4">
                    <ContentUnavailable />
                </Container>
            </>
        );
    }

    const completedAmount = milestones.filter(m => ['completed', 'approved'].includes(m.status)).reduce((sum, m) => sum + m.amount, 0);

    // Per-milestone fee from admin GlobalSettings (flat = per-milestone $, percentage = % of milestone)
    const feePerMilestone = (amt) => {
        if (feeType === 'percentage') return (Number(amt || 0) * Number(globalPercentageFee || 0)) / 100;
        return Number(globalFlatFee || 0);
    };
    const preTaxMilestoneTotal = (baseAmount) => {
        const fee = feePerMilestone(baseAmount);
        return Number((Number(baseAmount) + fee).toFixed(2));
    };
    const totalForMilestones = (list) => list.reduce(
        (sum, m) => sum + Number(m.amount || 0) + feePerMilestone(m.amount),
        0
    );

    const paidMilestones = milestones.filter(m => ['paid', 'completed', 'approved'].includes(m.status));
    const totalAmount = totalForMilestones(milestones);                  // sum of (amount + fee) across all milestones
    const totalAmount1 = milestones.reduce((sum, m) => sum + Number(m.amount || 0), 0); // sum of milestone amounts only
    const paidWithFees = totalForMilestones(paidMilestones);
    const platformFee = milestones.reduce((sum, m) => sum + feePerMilestone(m.amount), 0);
    const platformFeeLabel = feeType === 'percentage'
        ? `${Number(globalPercentageFee || 0)}%`
        : `$${Number(globalFlatFee || 0).toFixed(2)} / milestone`;

    const completedCount = paidMilestones.length;
    const remainingCount = milestones.length - completedCount;
    const progress = totalAmount > 0 ? remainingCount === 0 ? 100 : Math.round((completedCount / (remainingCount + completedCount)) * 100) : 0;
    //console.log(completedCount)
    //console.log(project.totalPaid)


    const startAdminChat = async () => {
    const authInfo = JSON.parse(localStorage.getItem('authInfo'));
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    // Debug: Check what's actually in localStorage
    // console.log('authInfo:', authInfo);
    // console.log('userInfo:', userInfo);
    // console.log('All localStorage keys:', Object.keys(localStorage));

    if (!authInfo) {
      console.error('No authInfo found in localStorage');
      alert('Please login first');
      return;
    }

    if (!userInfo) {
      console.error('No userInfo found in localStorage');
      alert('User information not found. Please refresh and try again.');
      return;
    }

    setLoading(true);

    try {
      // Get admin ID from environment variable
      const adminId = process.env.REACT_APP_SUPPORT_ADMIN_ID;

      if (!adminId) {
        throw new Error('Admin ID not configured');
      }

      // Create admin info object
      const adminInfo = {
        id: adminId,
        name: "Support Admin",
        image_url: "/admin-avatar.png", // or any default admin image
        isAdmin: true,
        role: 'Admin'
      };

      // Initiate chat (using user endpoint)
      const chatResponse = await axios.post('/user/accessChat', {
        receiverId: adminInfo,
        authorId: {
          id: authInfo.id,
          name: userInfo.name,
          image_url: userInfo.imgUrl || userInfo.image_url,
          role: 'User'
        }
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${authInfo.token}`
        }
      });

      if (chatResponse.data.status === true) {
        history.push({
          pathname: `/chat`, // User chat path
          state: {
            targetUserId: adminId,
            isAdminChat: true,
            adminInfo: adminInfo,
            chatType: 'support'
          }
        });
      }
    } catch (error) {
      console.error("Error starting admin chat:", error);
      alert('Failed to start chat with support. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  async function handleGetFlatFee() {
    const result = await getGlobalFeeSettings(authInfo);
    setGlobalFlatFee(result.flatFee);
    setGlobalPercentageFee(result.percentageFee);
    setFeeType(result.feeType);
    setVatGstEnabled(!!result.vatGstEnabled);
    setVatGstLabel(result.vatGstLabel || 'VAT/GST');
    if (result.success) {
        console.log('Flat Fee:', result.flatFee);
        console.log('Percentage Fee:', result.percentageFee);
        console.log('Fee Type:', result.feeType);
        console.log('Is Active:', result.isActive);
        console.log('Last Updated:', result.lastUpdated);
    } else {
        console.error('Failed to fetch fee settings:', result.error);
    }
}

    async function getGlobalFeeSettings(authInfo) {
        try {
            const { data } = await axios.get(
                '/user/platform-settings/global',
                {
                    headers: {
                        Authorization: `Bearer ${authInfo.token}`
                    }
                }
            );

            if (data.status) {
                return {
                    success: true,
                    flatFee: data.data.flatFee,
                    percentageFee: data.data.percentageFee,
                    feeType: data.data.feeType,
                    isActive: data.data.isActive,
                    lastUpdated: data.data.lastUpdated,
                    vatGstEnabled: data.data.vatGstEnabled,
                    vatGstLabel: data.data.vatGstLabel,
                };
            } else {
                throw new Error('API returned error status');
            }

        } catch (error) {
            console.error('Error fetching fee settings:', error);
            return {
                success: false,
                error: error.response?.data?.message || error.message,
                flatFee: 0,
                percentageFee: 0,
                feeType: 'flat',
                isActive: true,
                lastUpdated: null,
                vatGstEnabled: false,
                vatGstLabel: 'VAT/GST',
            };
        }
    }

    return (
        <>
            <Helmet><title>{"My Order - Pay Earth"}</title></Helmet>
            {loadingProject === true ? <SpinnerLoader /> : ""}
            <Header />
            <PageTitle title="My Orders" />

            <section className="inr_wrap orders_page">
                <Container className="py-4">
                    {/* Header Card */}
                    <Card bg="primary" text="white" className="shadow-sm border-0 mb-4">
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col>
                                    <h1 className="h4 mb-0">{project.title}</h1>
                                </Col>
                            </Row>

                            <Row className="align-items-center mt-3">
                                <Col xs="auto">
                                    <Image
                                        src={project.sellerId?.image_url || '/../../../assets/icons/placeholder.svg'}
                                        roundedCircle
                                        width={40}
                                        height={40}
                                        className="border border-white-50"
                                    />

                                </Col>
                                <Col>
                                    <p className="mb-0">{project.sellerId?.name}</p>
                                    <small className="text-white-50">
                                        {project.sellerId?.address?.country || 'Service Provider'} · Started {formatDate(project.createdAt)}
                                    </small>
                                </Col>
                                <Col xs="auto">

                                {(project.status === 'open' || project.status === 'disputed') && (
                                    <div className="d-flex align-items-center gap-2">
                                        <DisputeModal
                                        projectId={project._id}
                                        authInfo={authInfo}
                                        userRole={authInfo.id === project.clientId._id ? "client" : "seller"}
                                        againstUserId={authInfo.id === project.clientId._id ? project.sellerId?._id : project.clientId._id}
                                        againstUserModel="User"
                                        existingDispute={existingDispute}
                                        onDisputeFiled={(dispute) => {
                                            // Handle dispute filed - maybe refresh project data or show notification
                                            console.log('Dispute filed:', dispute);
                                            setExistingDispute(dispute);
                                            // Optional: Add a function to refresh project data here
                                        }}
                                    />
                                    {project.status === 'disputed' && (
                                        <Button
                                            variant="light"
                                            size="sm"
                                            className="d-flex align-items-center"
                                            onClick={startAdminChat}
                                        >
                                            Chat with Admin
                                        </Button>

                                    )}
                                    </div>
                                    )}

                                    <Badge
                                        bg={project.isActive ? (project.status === 'completed' ? 'success' : 'warning') : 'secondary'}
                                        className="px-3 py-2"
                                    >
                                        {project.isActive ? project.status.replace('-', ' ') : 'Inactive'}
                                    </Badge>
                                </Col>
                            </Row>

                            <Tab.Container activeKey={key} onSelect={setKey}>
                                <Nav variant="tabs" className="mt-4 border-0">
                                    <Nav.Item><Nav.Link eventKey="overview" className="">Overview</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="messages" className="">Messages</Nav.Link></Nav.Item>
                                    <Nav.Item><Nav.Link eventKey="contract" className="">Contract details</Nav.Link></Nav.Item>
                                </Nav>
                                <Tab.Content className="pt-3">
                                    <Tab.Pane eventKey="overview" />
                                    <Tab.Pane eventKey="messages" />
                                    <Tab.Pane eventKey="contract" />
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>

                    {/* Statistics */}
                    <Row className="text-dark mb-5">
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <small className="text-muted">Total Budget</small>
                            <h3 className="h5 mb-0">${totalAmount?.toFixed(2)}</h3>
                            <small className="text-muted">Fixed-price</small>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <small className="text-muted">Platform Fee</small>
                            <h3 className="h5 mb-0">${platformFee?.toFixed(2)}</h3>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <div className="d-flex align-items-center">
                                <small className="text-muted">Escrow Balance</small>
                                <Button variant="link" className="p-0 ms-1 text-muted"><FaInfoCircle size={14} /></Button>
                            </div>
                            <h3 className="h5 mb-0">${paidWithFees?.toFixed(2)}</h3>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <small className="text-muted">Milestones paid ({completedCount})</small>
                            <h3 className="h5 mb-0">${paidWithFees?.toFixed(2)}</h3>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <small className="text-muted">Remaining ({remainingCount})</small>
                            <h3 className="h5 mb-0">${(totalAmount - paidWithFees)?.toFixed(2)}</h3>
                        </Col>
                        <Col xs={12} md={6} lg={2} className="mb-4">
                            <small className="text-muted">Next Payout</small>
                            <h3 className="h5 mb-0">
                                ${(() => {
                                    const next = milestones.find(m =>
                                        ['paid','completed','approved','pending','in-progress'].includes(m.status)
                                    );
                                    if (!next) return '0';
                                    return preTaxMilestoneTotal(next.amount).toFixed(2);
                                })()}
                            </h3>
                        </Col>
                    </Row>

                    {/* Main Content */}
                    <Row>
                        <Col md={8}>
                            {key === 'overview' && (
                                <>
                                    <h2 className="h5 mb-4">Milestone Timeline</h2>
                                    {milestones.map((m, index) => (
                                        <MilestoneItem
                                            key={m._id}
                                            number={index + 1}
                                            milestone={m}
                                            project={project}
                                            onAccept={acceptMilestone}
                                            onPay={payMilestone}
                                            loading={loading}
                                            milestoneLoading={milestoneLoading[m._id] || false} // Pass individual loading state
                                            formatDate={formatDate}
                                            allMilestones={milestones}
                                            milestoneIndex={index}
                                            onReject={rejectMilestone}
                                            onDateChangeReview={handleDateChangeReview}
                                            loadingMilestoneId={loadingMilestoneId}
                                            displayPrice={preTaxMilestoneTotal(m.amount)}
                                        />
                                    ))}
                                </>
                            )}

                            {key === 'messages' && (
                                <div>
                                    <h4 className="mb-4 text-muted">Messages</h4>
                                    <Card className="p-5 text-center">
                                        <p className="text-muted mb-3">Start a conversation with your service provider.</p>
                                        <div>
                                            <Button variant="primary" onClick={() => handleChat(project?.sellerId?._id)}>Message Seller</Button>
                                        </div>
                                    </Card>
                                </div>
                            )}

                            {key === 'contract' && (
                                <div>
                                    <h4 className="mb-4 text-muted">Contract Details</h4>
                                    <Card className="p-4">
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <small className="text-muted">Project Title</small>
                                                    <p className="mb-0 mt-2">{project.title}</p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Budget</small>
                                                    <p className="mb-0 mt-2">${totalAmount?.toFixed(2)}</p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Platform Fee</small>
                                                    <p className="mb-0 mt-2">{platformFeeLabel}</p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Status</small>
                                                    <p className="mb-0 mt-2">{project.status}</p>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <small className="text-muted">
                                                        {feeType === 'flat' ? 'Global Flat Fee' : 'Global Percentage Fee'}
                                                    </small>
                                                    <p className="mb-0 mt-2">
                                                        {feeType === 'flat'
                                                            ? `$${globalFlatFee} / transaction`
                                                            : `${globalPercentageFee}% / transaction`
                                                        }
                                                    </p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Service Provider</small>
                                                    <p className="mb-0 mt-2">{project.sellerId?.name}</p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Start Date</small>
                                                    <p className="mb-0 mt-2">{formatDate(project.createdAt)}</p>
                                                </div>
                                                <div className="mb-3">
                                                    <small className="text-muted">Total Milestones</small>
                                                    <p className="mb-0 mt-2">{milestones.length}</p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>
                            )}
                        </Col>

                        {/* Sidebar */}
                        <Col md={4}>
                            <Card className="shadow-sm border-0" style={{ position: 'sticky', top: '20px' }}>
                                <Card.Body className="p-4">
                                    <h5 className="mb-4">Contract Summary</h5>

                                    <div className="d-flex justify-content-between mb-3">
                                        <span className="text-muted">Total Budget</span>
                                        <strong>${totalAmount?.toFixed(2)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between mb-3">
                                        <span className="text-muted text-success">Paid</span>
                                        <strong className="text-success">${paidWithFees?.toFixed(2)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between mb-4">
                                        <span className="text-muted">Remaining</span>
                                        <strong>${(totalAmount - paidWithFees)?.toFixed(2)}</strong>
                                    </div>

                                    {/* Progress Bar */}
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="small text-muted">Progress</span>
                                            <span className="small text-muted">{progress}%</span>
                                        </div>
                                        <div style={{
                                            width: '100%',
                                            height: '8px',
                                            backgroundColor: '#e9ecef',
                                            borderRadius: '4px',
                                            position: 'relative'
                                        }}>
                                            <div style={{
                                                width: `${progress}%`,
                                                height: '100%',
                                                backgroundColor: '#007bff',
                                                borderRadius: '4px'
                                            }}></div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <span className="text-muted">Milestones Completed</span>
                                        <strong>{completedCount} / {milestones.length}</strong>
                                    </div>
                                    <div className='d-flex justify-content-center mt-3'>
                                        {project?.status === 'completed' &&
                                        Array.isArray(milestones) &&
                                        milestones.every(m => m.status === 'approved') ? (
                                            projectReview ? (
                                            <div className="text-center mt-3">
                                                <h5 className='mb-2'>Your Feedback</h5>
                                                <h6 className="mb-2">{projectReview?.review?.title}</h6>
                                                <div className="mb-2">
                                                {[...Array(5)].map((_, i) => {
                                                    const rating = projectReview?.rating || 0;
                                                    const full = i + 1 <= Math.floor(rating);
                                                    const half = i + 1 > Math.floor(rating) && rating % 1 >= 0.5;
                                                    return (
                                                    <i
                                                        key={i}
                                                        className={`me-1 bi ${
                                                        full
                                                            ? 'bi-star-fill text-warning'
                                                            : half
                                                            ? 'bi-star-half text-warning'
                                                            : 'bi-star text-muted'
                                                        }`}
                                                    ></i>
                                                    );
                                                })}
                                                </div>
                                            </div>
                                            ) : (
                                            <button
                                                className={`btn custom_btn btn_yellow w-auto d-inline-block ${
                                                !authInfo || authInfo.id === undefined ? 'disabled' : ''
                                                }`}
                                                onClick={() =>
                                                authInfo && authInfo.id !== undefined && setOpenReviewModal(!openReviewModal)
                                                }
                                            >
                                                Write a review
                                            </button>
                                            )
                                        ) : null}
                                        </div>

                                    {/* {console.log("IS TRUE: ", isProductProject)}
                                    {console.log("PROJECT ID: ", projectId)} */}
                                    {/* Conditional Modal Rendering */}
                                    {isProductProject ? (
                                        <ProductModel
                                            isOpen={openReviewModal}
                                            onClose={() => setOpenReviewModal(false)}
                                            productId={productId}
                                            projectId={projectId} //Pass projectId from useParams
                                            authInfo={authInfo}
                                            fetchApi={() => { }}
                                            fetchRating={() => { }}
                                        />
                                    ) : (
                                        <ServiceModel
                                            isOpen={openReviewModal}
                                            onClose={() => setOpenReviewModal(false)}
                                            serviceId={project?.serviceId?._id}
                                            projectId={projectId} //Pass projectId to ServiceModel too
                                            authInfo={authInfo}
                                            fetchApi={() => { }}
                                        />
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <DateChangeReviewModal
                        show={showDateChangeReviewModal}
                        onHide={() => setShowDateChangeReviewModal(false)}
                        milestone={selectedMilestone}
                        onSuccess={handleDateChangeReviewSuccess}
                    />

                    {/* Payment Modal */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Pay Milestone: {selected?.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {paymentBreakdown && (
                                <div className="border rounded p-3 mb-3 bg-light small">
                                    <div className="d-flex justify-content-between mb-1">
                                        <span>Milestone</span>
                                        <span>${Number(paymentBreakdown.milestoneAmount || 0).toFixed(2)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-1">
                                        <span>Platform fee</span>
                                        <span>${Number(paymentBreakdown.platformFee || 0).toFixed(2)}</span>
                                    </div>
                                    {paymentBreakdown.automaticTaxEnabled && Number(paymentBreakdown.taxAmount) > 0 && (
                                        <div className="d-flex justify-content-between mb-1">
                                            <span>{paymentBreakdown.taxLabel || vatGstLabel || 'Tax'} (Stripe)</span>
                                            <span>${Number(paymentBreakdown.taxAmount).toFixed(2)}</span>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between fw-semibold border-top pt-2 mt-2">
                                        <span>Total</span>
                                        <span>${Number(paymentBreakdown.totalInclusive || 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Name on Card</Form.Label>
                                    <Form.Control type="text" placeholder="Cardholder name" required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Card Number</Form.Label>
                                    <div className="form-control"><CardNumberElement /></div>
                                </Form.Group>
                                <Row>
                                    <Col>
                                        <Form.Label>Expiry</Form.Label>
                                        <div className="form-control"><CardExpiryElement /></div>
                                    </Col>
                                    <Col>
                                        <Form.Label>CVC</Form.Label>
                                        <div className="form-control"><CardCvcElement /></div>
                                    </Col>
                                </Row>
                                <div className="d-flex align-items-center mt-2">
                                    <FaInfoCircle className="text-muted me-2" size={14} />
                                    <small className="text-muted">
                                        {feeType === 'flat'
                                            ? `Includes a Flat Fee ($${globalFlatFee})`
                                            : `Includes a Percentage Fee (${globalPercentageFee}%)`
                                        }
                                    </small>
                                </div>
                                <Button type="submit" variant="primary" className="mt-3 w-100" disabled={loading}>
                                    {loading ? 'Processing…' : `Pay $${Number(paymentBreakdown?.totalInclusive ?? preTaxMilestoneTotal(selected?.amount)).toFixed(2)}`}
                                </Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </Container>
            </section>

            {/* <ServiceModel isOpen={openReviewModal} onClose={() => setOpenReviewModal(false)} serviceId={project?.serviceId?._id} authInfo={authInfo} fetchApi={() => { }} /> */}
        </>
    );
}

// Status variants for milestones
const STATUS_VARIANTS = {
    pending: 'primary',
    'in-progress': 'info',
    completed: 'warning',
    approved: 'success',
    rejected: 'danger',
    paid: 'success'
};

const STATUS_COLORS = {
    pending: 'text-white',
    'in-progress': 'text-white',
    completed: 'text-white',
    approved: 'text-white',
    rejected: 'text-white',
    paid: 'text-white'
};

function MilestoneItem({ number, milestone, project, onAccept, onPay, loading, formatDate, allMilestones, milestoneIndex, onReject, milestoneLoading, onDateChangeReview, loadingMilestoneId, displayPrice }) {
    const variant = STATUS_VARIANTS[milestone.status] || 'light';
    const color = STATUS_COLORS[milestone.status] || 'text-dark';

    const previousMilestones = allMilestones.slice(0, milestoneIndex);
    const allPreviousApproved = previousMilestones.every(m => m.status === 'approved');

    const [rejectionReason, setRejectionReason] = useState('');
    const [showRejectModal, setShowRejectModal] = useState(false);

    const handleReject = async () => {
        if (!rejectionReason.trim()) {
            toast.error('Please provide a reason for rejection');
            return;
        }

        await onReject(milestone, rejectionReason);
        setShowRejectModal(false);
        setRejectionReason('');
    };


    return (
        <Card className="mb-4 shadow-sm">
            <Card.Body>
                <Row className="align-items-start">
                    <Col xs="auto" className="pe-0">
                        <Badge bg="light" text="dark" pill>
                            {number}
                        </Badge>
                    </Col>
                    <Col>
                        <h3 className="h6 mb-2">{milestone.name}</h3>
                        <div className="d-flex align-items-center mb-2">
                            <strong>${Number(displayPrice ?? milestone.amount).toFixed(2)}</strong>
                            <Badge bg={variant} className={`ms-2 ${color}`} pill>
                                {milestone.status === 'paid' ? 'Paid' :
                                    milestone.status === 'approved' ? 'Approved' :
                                        milestone.status === 'completed' ? 'Awaiting Review' :
                                            milestone.status.replace('-', ' ')}
                            </Badge>
                        </div>

                        {/* Date Change Request Notification */}
                        {milestone.dueDateChangeRequest && milestone.dueDateChangeRequest.status === 'pending' && (
                            <div className="alert alert-warning py-2 mb-3">
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <strong>Date Change Request</strong><br/>
                                        <small>
                                            Requested date: {formatDate(milestone.dueDateChangeRequest.requestedDate)}<br/>
                                            Reason: {milestone.dueDateChangeRequest.reason}
                                        </small>
                                    </div>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => onDateChangeReview(milestone)}
                                    >
                                        Review Request
                                    </Button>
                                </div>
                            </div>
                        )}

                        {/* Date Change Request Status */}
                        {milestone.dueDateChangeRequest && milestone.dueDateChangeRequest.status === 'approved' && (
                            <div className="alert alert-success py-2 mb-3">
                                <small>
                                    <strong>Date Change Approved</strong><br/>
                                    Due date updated to: {formatDate(milestone.dueDate)}
                                </small>
                            </div>
                        )}

                        {milestone.dueDateChangeRequest && milestone.dueDateChangeRequest.status === 'rejected' && (
                            <div className="alert alert-info py-2 mb-3">
                                <small>
                                    <strong>Date Change Request Rejected</strong><br/>
                                    Original due date maintained: {formatDate(milestone.dueDate)}
                                </small>
                            </div>
                        )}

                        {milestone.dueDate && (
                            <div className="d-flex align-items-center text-muted mb-3">
                                <FaCalendarAlt className="me-2" size={14} />
                                <small>Due {formatDate(milestone.dueDate)}</small>
                            </div>
                        )}

                        <p className="text-muted mb-3 small">{milestone.description}</p>

                        {/* Action buttons based on status */}
                        {milestone.status === 'completed' && project.isActive && (
                            <div className="mb-3">
                                <small className="text-warning d-block mb-2">Action required</small>

                                {/* Submitted Files Section */}
                                <div className="mb-2">
                                    <strong className="d-block mb-1">Submitted Files:</strong>
                                    <ul className="list-unstyled">
                                        {milestone.submittedFiles && milestone.submittedFiles.length > 0 &&
                                            milestone.submittedFiles.map((file, index) => (
                                                <li key={index}>
                                                    <a
                                                        href={file.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download
                                                    >
                                                        {file.name || `File ${index + 1}`}
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                </div>



                                <div className="d-flex align-items-start mb-3">
                                    <FaCircle className="text-warning me-2 mt-1" size={8} />
                                    <small className="text-muted">
                                        Review and approve the completed work
                                    </small>
                                </div>

                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    onClick={() => onAccept(milestone)}
                                    disabled={milestoneLoading || loading} // Disable when loading
                                >
                                    {milestoneLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Accepting...
                                        </>
                                    ) : (
                                        'Accept Milestone'
                                    )}
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => setShowRejectModal(true)}
                                >
                                    Reject Milestone
                                </Button>

                                {milestone.isRejected && (
                                <div className="rejection-info">
                                    <p><strong>Status:</strong> Rejected - needs revision</p>
                                </div>
                            )}

                            {/* Rejection Modal */}
                            {showRejectModal && (
                                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Reject Milestone</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowRejectModal(false)}
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                                <textarea
                                                    value={rejectionReason}
                                                    onChange={(e) => setRejectionReason(e.target.value)}
                                                    placeholder="Please provide a reason for rejection..."
                                                    rows="4"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="modal-footer">
                                                <Button
                                                    variant="secondary"
                                                    onClick={() => setShowRejectModal(false)}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    onClick={handleReject}
                                                >
                                                    Submit Rejection
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            </div>
                        )}




                        {(milestone.status === 'pending' || milestone.status === 'in-progress') && project.isActive && (
                            <div className="mb-3">
                                <small className="text-success d-block mb-2">Ready for payment</small>
                                <div className="d-flex align-items-start mb-2">
                                    <FaCircle className="text-success me-2 mt-1" size={8} />
                                    <small className="text-muted">
                                        Please make the payment to the service provider to approve the milestone.
                                    </small>
                                </div>

                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => onPay(milestone)}
                                    disabled={loadingMilestoneId === milestone._id || !allPreviousApproved}
                                    >
                                    {loadingMilestoneId === milestone._id
                                        ? 'Processing…'
                                        : `Pay $${Number(displayPrice ?? milestone.amount).toFixed(2)}`}
                                </Button>

                                {!allPreviousApproved && (
                                    <p className="text-danger mt-2 mb-0" style={{ fontSize: '13px' }}>
                                        All previous milestones must be approved before proceeding with payment.
                                    </p>
                                )}
                            </div>
                        )}


                        {milestone.status === 'paid' && (
                            <div className="d-flex align-items-center text-success">
                                <CheckCircle className="me-2" size={16} />
                                <small>Payment completed</small>
                            </div>
                        )}

                        {milestone.status === 'in-progress' && project.isActive && (
                            <div className="mb-3">
                                <small className="text-info d-block mb-2">In progress</small>
                                <div className="d-flex align-items-start mb-3">
                                    <FaCircle className="text-info me-2 mt-1" size={8} />
                                    <small className="text-muted">
                                        Service provider is working on this milestone
                                    </small>
                                </div>
                            </div>
                        )}

                        {/* Files Section */}
                        {milestone.attachments && milestone.attachments.length > 0 && (
                            <div className="mt-3 pt-3 border-top">
                                <div className="mb-2">
                                    <small className="text-muted">Deliverables ({milestone.attachments.length})</small>
                                </div>
                                <div className="row g-2">
                                    {milestone.attachments.slice(0, 3).map((f, i) => (

                                        <div key={i} className="col-auto">
                                            <a
                                                href={`${config.apiURI}${f.filePath.startsWith('/') ? f.filePath.substring(1) : f.filePath}`}
                                                download
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none"
                                            >
                                                <div className="d-flex align-items-center p-2 bg-light rounded">
                                                    <FaFile className="me-2 text-muted" size={12} />
                                                    <small className="text-truncate" style={{ maxWidth: '100px' }}>
                                                        {f.fileName}
                                                    </small>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                    {milestone.attachments.length > 3 && (
                                        <div className="col-auto">
                                            <small className="text-muted">+{milestone.attachments.length - 3} more</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default function ServiceMilestoneCheckout() {
    return (
        <StripeProvider>
            <OrderDetailsPage />
        </StripeProvider>
    )
}
